import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function LoParReportScreen() {
  return (
    <PlaceholderScreen
      icon="📊"
      title="LO PAR Report"
      subtitle="This report shows portfolio at risk metrics and analysis. This report will be available in a future update."
    />
  )
}
